import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { logoutSuccess, setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import { clearFilter } from "../../../store/filter/filterReducer"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import { Fade, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import TranslatedText from "../../../utils/Translate"
import { useSelector } from "react-redux"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function AnalysisTemplates() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])

    const { showSnackbar } = useSnackbar();

    const [filterParams, setFilterParams] = useState({
        code: '',
        partner: '',
        conversationtemplate: ''
    })

    useEffect(() => {
        dispatch(setCurrentPage(`Analysis Templates`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )



    //Get analysis templates
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/analysistemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //on load - fetch data

    //on load - fetch data
    useEffect(() => {
        // fetchData(filterParams)
        getConversationtemplates()
        accesslevel === "5" && getPartners()
    }, [])

    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])


    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "space-between" }}>
                {accesslevel != '3' ?
                    <Link to='/analysistemplate' state={{ type: 'add' }}>
                        <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={'Add Analisis template'} /></Button>
                    </Link> : <Box />}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 24 }}>
                    <TextField value={filterParams.code} onChange={(e) => setFilterParams({ ...filterParams, code: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Сode'} />} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, conversationtemplate: e.target.value })} value={filterParams.conversationtemplate} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            <MenuItem value={''}><TranslatedText text={'General and private'} /></MenuItem>
                            {
                                conversationtemplates.map((el: any) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    {accesslevel == '5' &&
                        <FormControl>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                            <Select sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.partner} onChange={(e) => setFilterParams({ ...filterParams, partner: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                <MenuItem value={''}><TranslatedText text={'Owner'} /></MenuItem>
                                <MenuItem value={'0'}><TranslatedText text={'General and private'} /></MenuItem>
                                {
                                    partners.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    }


                    <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    <SimplifiedTable rows={tableData} page={'analysistemplate'} />
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}
